import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { analytics } from '../utils/analytics'

const RouteTracker = () => {
  const location = useLocation()

  useEffect(() => {
    // Track page view on route change
    const trackPageView = () => {
      // Small delay to ensure the page has loaded
      setTimeout(() => {
        analytics.pageView(location.pathname + location.search)
      }, 100)
    }

    trackPageView()
  }, [location])

  // This component doesn't render anything
  return null
}

export default RouteTracker
